var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrabajoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.036,
    height: 38.46,
    viewBox: "0 0 24.036 38.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7827ee;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.298 -1.027)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.298 1.027)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.31,71.082a1.516,1.516,0,0,0,.874.256A2.875,2.875,0,0,0,22.44,71a2.893,2.893,0,0,0,1.259.343,1.512,1.512,0,0,0,.874-.256,5.271,5.271,0,0,0,2.2-3.564.74.74,0,0,0-.665-.849.884.884,0,0,1-.8-.877.867.867,0,0,1,.237-.6.74.74,0,0,0-.235-1.18,3.122,3.122,0,0,0-.96-.241.73.73,0,0,0,.112-.506.742.742,0,0,0-.846-.618,2.133,2.133,0,0,0-.49.141,2.15,2.15,0,0,0-1.9-1.1h0a.745.745,0,0,0-.569.28,2.131,2.131,0,0,0-.409,1.827,2.608,2.608,0,0,0-2.2,2.769A5.3,5.3,0,0,0,20.31,71.082ZM21.945,63.5a1.621,1.621,0,0,1,.166.715,1.582,1.582,0,0,1-.467-.566,1.623,1.623,0,0,1-.163-.713A1.569,1.569,0,0,1,21.945,63.5Zm-1.015,1.716a1.585,1.585,0,0,1,.827.191,1.425,1.425,0,0,0,.7.192,1.253,1.253,0,0,0,.715-.224,1.587,1.587,0,0,1,.726-.158,2.371,2.371,0,0,0,1.262,2.706,3.775,3.775,0,0,1-1.411,1.93.232.232,0,0,1-.053,0,1.682,1.682,0,0,1-.655-.215,1.513,1.513,0,0,0-.616-.135,1.277,1.277,0,0,0-.65.166,1.6,1.6,0,0,1-.631.189,3.837,3.837,0,0,1-1.624-3.28A1.234,1.234,0,0,1,20.929,65.214Z",
    transform: "translate(-10.395 -35.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.809,20.518A8.661,8.661,0,1,0,6.6,27.168,10.094,10.094,0,0,0,3.186,31.03a.728.728,0,0,0-.052.473h-1.2a.738.738,0,0,0-.739.78l.65,11.885H1.038a.741.741,0,0,0,0,1.481H23.593a.741.741,0,1,0,0-1.481h-.806l.65-11.885a.739.739,0,0,0-.739-.78H21.31a.641.641,0,0,0-.025-.107,10.079,10.079,0,0,0-3.591-4.228A8.671,8.671,0,0,0,20.809,20.518Zm1.106,12.466L21.3,44.168H3.329L2.717,32.984Zm-7.227-4.925a.743.743,0,0,0,.978.376c.24-.106.469-.225.695-.351A8.577,8.577,0,0,1,19.684,31.5H4.616A8.593,8.593,0,0,1,7.93,28.086a8.671,8.671,0,0,0,2.038.817.731.731,0,0,0,.187.023.74.74,0,0,0,.185-1.457,7.18,7.18,0,1,1,4.726-.388A.741.741,0,0,0,14.689,28.059Z",
    transform: "translate(-0.298 -7.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.767,39.684a.739.739,0,0,0-1.033-.17,2.706,2.706,0,0,1-3.191.017A.741.741,0,0,0,21.63,40.7a4.268,4.268,0,0,0,2.526.833,4.128,4.128,0,0,0,2.442-.814A.741.741,0,0,0,26.767,39.684Z",
    transform: "translate(-12.275 -22.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.459,31.975a.88.88,0,1,0-.881.878A.881.881,0,0,0,22.459,31.975Z",
    transform: "translate(-11.906 -18.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.691,32.853a.879.879,0,1,0-.883-.878A.879.879,0,0,0,31.691,32.853Z",
    transform: "translate(-17.659 -18.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.543,3.808V1.767a.74.74,0,0,0-1.481,0v2.04a.74.74,0,0,0,1.481,0Z",
    transform: "translate(-11.544 -1.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.537,7.3a.741.741,0,0,0,.6-1.17L8.958,3.056a.741.741,0,1,0-1.208.857L9.932,6.988A.741.741,0,0,0,10.537,7.3Z",
    transform: "translate(-4.46 -2.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.234,12.081a.741.741,0,0,0,.276,1.011l2,1.144a.73.73,0,0,0,.366.1.74.74,0,0,0,.368-1.383l-2-1.144A.739.739,0,0,0,1.234,12.081Z",
    transform: "translate(-0.775 -7.105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrabajoLogo);
export default __webpack_public_path__ + "static/media/trabajo_logo.a2a66683a3200b803489be08b75a7ec4.svg";
export { ForwardRef as ReactComponent };